import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PushModule } from '@rx-angular/template/push';
import { LetModule } from '@rx-angular/template/let';
import { IfModule } from '@rx-angular/template/experimental/if';
import { RxRenderStrategiesConfig, RX_RENDER_STRATEGIES_CONFIG } from '@rx-angular/cdk/render-strategies';

import { devTools } from '@ngneat/elf-devtools';
import { enableElfProdMode } from '@ngneat/elf';

/*import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import {
  GoogleLoginProvider, GoogleSigninButtonDirective
} from '@abacritt/angularx-social-login';*/

import { NgxMatomoTrackerModule } from '@ngx-matomo/tracker';
import { NgxMatomoRouterModule } from '@ngx-matomo/router';

import { AppRoutingModule } from './routing/app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from '@app/graphql';
import { UiModule } from '@app/ui';
import { PagesModule } from '@app/pages';
import { ScrollDirective } from '@app/ui';
import { DynamicDirective } from '@app/data';

import { environment } from '../environments/environment';
import { AuthConfigModule } from './auth/auth-config.module';

if (environment.production) {
  enableElfProdMode();
}
else {
  devTools();
}

const CUSTOM_RX_ANGULAR_CONFIG: RxRenderStrategiesConfig<string> = {
  primaryStrategy: 'global',
  patchZone: false,
};

/*const googleLoginOptions = {
  oneTapEnabled: true,
  scopes: ['openid', 'profile', 'email'],
  prompt_parent_id: 'google-popup'
};*/

@NgModule({
  declarations: [
    AppComponent,
    ScrollDirective,
    DynamicDirective
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    GraphQLModule,
    AppRoutingModule,
    UiModule,
    PagesModule,
    environment.modules,
    LetModule,
    PushModule,
    //SocialLoginModule,
    NgxMatomoRouterModule,
    NgxMatomoTrackerModule.forRoot({
      trackerUrl: 'https://matomo.mynatomame.cz',
      siteId: '1',
    }),
    AuthConfigModule,
  ],
  providers: [
    {
      provide: RX_RENDER_STRATEGIES_CONFIG,
      useValue: CUSTOM_RX_ANGULAR_CONFIG,
    }/*,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '244767285438-depsfibc7dbc6ciq656v6g6fl53g4poj.apps.googleusercontent.com',
              googleLoginOptions
            )
          }
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }*/
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
